<ng-container *ngIf="showSkeleton; else generalInfoContent">
  <div class="pod-skeleton">
    <div class="pod-skeleton__title"></div>
    <div class="pod-grid">
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
    </div>
  </div>
</ng-container>

<ng-template #generalInfoContent>
  <div class="pod-section" [formGroup]="form">

    <div class="pod-owner-banner" *ngIf="ownerBannerMessage">

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58236 4 4 7.58236 4 12C4 16.4176 7.58236 20 12 20C16.4186 20 20 16.4177 20 12C20 7.58227 16.4186 4 12 4ZM1.5 12C1.5 6.20164 6.20164 1.5 12 1.5C17.7994 1.5 22.5 6.20173 22.5 12C22.5 17.7983 17.7994 22.5 12 22.5C6.20164 22.5 1.5 17.7984 1.5 12ZM11.9951 6.9541C12.6854 6.9541 13.2451 7.51375 13.2451 8.2041V12.6231C13.2451 13.3135 12.6854 13.8731 11.9951 13.8731C11.3047 13.8731 10.7451 13.3135 10.7451 12.6231V8.2041C10.7451 7.51375 11.3047 6.9541 11.9951 6.9541ZM11.9951 14.5459C11.3047 14.5459 10.7451 15.1055 10.7451 15.7959C10.7451 16.4863 11.3047 17.0459 11.9951 17.0459H12.0051C12.6954 17.0459 13.2551 16.4863 13.2551 15.7959C13.2551 15.1055 12.6954 14.5459 12.0051 14.5459H11.9951Z" fill="#FF441F"/>
      </svg>
      <p class="pod-owner-banner__text">{{ ownerBannerMessage }}</p>
    </div>

    <h2 class="pod-section__title">{{ sectionLabel }}</h2>

    <div class="pod-grid">

      <div class="pod-field" *ngIf="isBusinessUnitVisible" [class.pod-field--error]="isInvalid(F.BUSINESS_UNIT)">
        <one-select
          #businessUnitSelect
          [config]="selectConfig"
          [dataSource]="selectSources[F.BUSINESS_UNIT]"
          [label]="LABELS[F.BUSINESS_UNIT]"
          [disabled]="businessUnitSelectDisabled"
          (selectionChanged)="onBusinessUnitChange($event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.BUSINESS_UNIT)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.PURCHASE_ORDER_NAME)">
        <one-input
          [formControlName]="F.PURCHASE_ORDER_NAME"
          [label]="LABELS[F.PURCHASE_ORDER_NAME]"
        ></one-input>
        <span class="pod-field__error" *ngIf="isInvalid(F.PURCHASE_ORDER_NAME)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.SOURCE_TYPE)">
        <one-select
          #sourceTypeSelect
          *ngIf="selectSources[F.SOURCE_TYPE]"
          [config]="selectConfig"
          [dataSource]="selectSources[F.SOURCE_TYPE]"
          [label]="LABELS[F.SOURCE_TYPE]"
          [disabled]="sourceTypeSelectDisabled"
          (selectionChanged)="onSelectChange(F.SOURCE_TYPE, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.SOURCE_TYPE)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isMakerToExecuteVisible" [class.pod-field--error]="isInvalid(F.MAKER_TO_EXECUTE)">
        <one-select
          #makerSelect
          [config]="makerSelectConfig"
          [dataSource]="selectSources[F.MAKER_TO_EXECUTE]"
          [label]="LABELS[F.MAKER_TO_EXECUTE]"
          (selectionChanged)="onMakerChange($event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.MAKER_TO_EXECUTE)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isBrandGroupToExecuteVisible" [class.pod-field--error]="isInvalid(F.BRAND_GROUP_TO_EXECUTE_ID)">
        <one-select
          #brandGroupSelect
          [config]="makerSelectConfig"
          [dataSource]="selectSources[F.BRAND_GROUP_TO_EXECUTE_ID]"
          [label]="LABELS[F.BRAND_GROUP_TO_EXECUTE_ID]"
          (selectionChanged)="onBrandGroupChange($event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.BRAND_GROUP_TO_EXECUTE_ID)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isPoTypeVisible" [class.pod-field--error]="isInvalid(F.PO_TYPE)">
        <one-select
          #poTypeSelect
          *ngIf="selectSources[F.PO_TYPE]"
          [config]="selectConfig"
          [dataSource]="selectSources[F.PO_TYPE]"
          [label]="LABELS[F.PO_TYPE]"
          [disabled]="isPoTypeDisabled"
          (selectionChanged)="onSelectChange(F.PO_TYPE, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.PO_TYPE)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.OWNER) || ownerInvalid">
        <div class="pod-owner-skeleton" *ngIf="ownerValidating"></div>
        <one-select
          #ownerSelect
          [config]="searchSelectConfig"
          [dataSource]="selectSources[F.OWNER]"
          [label]="LABELS[F.OWNER]"
          (selectionChanged)="onSelectChange(F.OWNER, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.OWNER)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isParentPoVisible">
        <one-input
          [formControlName]="F.PARENT_PO"
          [label]="LABELS[F.PARENT_PO]"
          [disabled]="isParentPoDisabled"
        ></one-input>
      </div>

      <div class="pod-field" *ngIf="isSelfServiceCampaignIdVisible">
        <one-input
          [formControlName]="F.SELF_SERVICE_CAMPAIGN_ID"
          [label]="LABELS[F.SELF_SERVICE_CAMPAIGN_ID]"
        ></one-input>
      </div>

    </div>
  </div>
</ng-template>
